import Swal from 'sweetalert2'

// eslint-disable-next-line no-undef
const object = casanovaObject

const blockDiv = (el) => {
  el.prepend(object.loader)
  el.addClass('loading-div')
}

const unBlockDiv = (el) => {
  el.find('.casanova-loader').remove()
  el.removeClass('loading-div')
}

const debounce = (fn, threshold) => {
  let timeout
  threshold = threshold || 100
  return function debounced() {
    clearTimeout(timeout)
    let args = arguments
    let _this = this
    function delayed() {
      fn.apply(_this, args)
    }
    timeout = setTimeout(delayed, threshold)
  }
}

const modalAlertTemplate = (args) => {
  return `<div class="modal modal-alert ${args.classes}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        ${object.loader}
                        <p>${args.body}</p>
                    </div>
                </div>
            </div>
        </div>`
}

const animate = (node, animation, prefix = '') =>
  new Promise((resolve) => {
    const animationName = `${prefix}${animation}`

    node.classList.add(`${prefix}animated`, animationName)

    function handleAnimationEnd(event) {
      event.stopPropagation()
      node.classList.remove(`${prefix}animated`, animationName)
      resolve('Animation ended')
    }

    node.addEventListener('animationend', handleAnimationEnd, { once: true })
  })

const alert = Swal.mixin({})

const Alert = (success = true, message = '', duration = 6000) => {
  Swal.close()
  let type
  if (typeof success === 'boolean') {
    type = success ? 'success' : 'error'
  } else {
    type = success
  }

  alert.fire({
    icon: type,
    title: message,
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: duration,
    timerProgressBar: true,
    iconColor: 'white',
    customClass: {
      popup: 'casanova-toast-popup',
      container: 'casanova-toast',
    },
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
      toast.addEventListener('click', Swal.close)
    },
  })
}

export { blockDiv, unBlockDiv, debounce, modalAlertTemplate, animate, Alert }

export const getTextNodesIn = (node) => {
  let textNodes = []
  let nodeStack = [node]

  while (nodeStack.length > 0) {
    const currentNode = nodeStack.pop()
    if (currentNode.nodeType === Node.TEXT_NODE) {
      textNodes.push(currentNode)
    } else if (currentNode.nodeType === Node.ELEMENT_NODE) {
      const children = currentNode.childNodes
      for (let i = children.length - 1; i >= 0; i--) {
        nodeStack.push(children[i])
      }
    }
  }

  return textNodes
      .map((node) => node.textContent.trim())
      .join('')
      .replace(/\s+/g, ' ')
}
